// Single source of truth for Speedy Resurfacing contact details.
// Only these values may appear anywhere on the site.
export const BRAND = "Speedy Resurfacing";
export const DOMAIN = "https://www.speedyresurfacing.com.au";
export const PHONE_DISPLAY = "0466 495 495";
export const PHONE_TEL = "tel:+61466495495";
export const EMAIL = "info@speedyresurfacing.com.au";
export const EMAIL_MAILTO = "mailto:info@speedyresurfacing.com.au";
export const TIMEZONE = "Australia/Sydney";
export const TIMEZONE_LABEL = "Sydney time (AEST/AEDT)";
export const INSTAGRAM_HANDLE = "@speedyresurfacing";
export const INSTAGRAM_URL = "https://www.instagram.com/speedyresurfacing/";
export const FACEBOOK_URL = "https://www.facebook.com/profile.php?id=61595126452845";
export const TAGLINE = "Built on lines. Perfected on courts.";
